import { cm } from '~/utils/utils'

export interface ErrorLogTerminalProps {
  value: string
  className?: string
  contentClassName?: string
  'data-testid'?: string
}

export function ErrorLogTerminal({
  value,
  className,
  contentClassName,
  'data-testid': testId = 'error-log-terminal'
}: ErrorLogTerminalProps) {
  return (
    <div
      className={cm(
        'min-w-0 overflow-hidden rounded-[12px] border border-tokens-neutral-border-1 bg-tokens-neutral-bg-action shadow-heavy',
        className
      )}
    >
      <pre
        className={cm(
          'max-h-56 min-h-[120px] overflow-y-scroll overscroll-contain whitespace-pre-wrap bg-tokens-neutral-bg-action p-3 font-mono text-[12px] leading-5 text-tokens-status-success-3 [overflow-wrap:anywhere] [scrollbar-gutter:stable]',
          contentClassName
        )}
        data-testid={testId}
      >
        {value}
      </pre>
    </div>
  )
}
